import './App.css';
import { AllRoutes } from './routes/AllRoutes';

function App() {
  
  return (
    <>
      {/* <Header />
      <Main />
      <Footer /> */}
      < AllRoutes />
    </>
  );
}

export default App;
